/* eslint-disable complexity */
import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { ProgramsType } from "~/api/types/Programs"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"

import { Raw } from "../raw"
import { Items } from "./components/Items/Items"
import styles from "./index.module.css"

export type ProgramsProps = {
  slug?: string
  title?: string
  inHome?: boolean
}

export const Programs: React.FC<ProgramsProps> = ({ slug, title, inHome = false }) => {
  const { t } = useTranslation()
  const { name } = useApiContext("/programs/element")
  const apiUrl = slug !== "career" ? "/programs/list" : "/careerprograms/list"
  const programs = useApiContext(apiUrl)

  if (!inHome && programs.length === 0) {
    return null
  }

  const programsWithoutCurrentProgram = programs.reduce((prev: ProgramsType[], curr) => {
    if (curr.name !== name) {
      prev.push(curr)
    }

    return prev
  }, [])

  if (programsWithoutCurrentProgram.length === 0) {
    return null
  }

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <div className={styles.Top}>
          <div className={styles.Title}>
            <Heading as="h2" like="h1">
              <Raw html={title ?? t("Programs.Title")} />
            </Heading>

            {!inHome && slug !== "career" && (
              <Link className={styles.Link} href="/sustainable-development/programs" view="arrow">
                <Raw html={t("Programs.Link")} />
              </Link>
            )}
          </div>

          {inHome && (
            <div className={styles.Text}>
              <Raw html={t("home.Development.Text")} />
              <Link className={styles.Link} href="/sustainable-development" view="arrow">
                <Raw html={t("home.Development.Link")} />
              </Link>
            </div>
          )}
        </div>

        <Items className={styles.Items} programs={programsWithoutCurrentProgram} slug={slug} />
      </div>
    </div>
  )
}
